import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd, MdTransferWithinAStation } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'

class PosMembershipPromoForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      membership_id: this.props.match.params.id,
      id: '',
      name: '',
      promo_code: '',
      promo_type: '',
      options: '',
      compare_type: '',
      compare_value: '',
      start_date: '',
      end_date: '',
      issue_limit: '',
      issued: '',
      claim_limit: '',
      applied_tier: '',
      tier_name: '',
      tier_id: '',
      promo_id: '',
      promoList: [],
      membership_promo: this.props.data.membership_promo,
      filter_membership_tier: this.props.data.membership_tier,
      membership_tier: this.props.data.membership_tier,
    }
  }

  componentDidMount() {
    this.Promo()
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId
        const data = this.props.data.membership_tier.find(e => e.id === id)
        this.setState({
          id: data.id,
          name: data.name,
          promo_code: data.promo_code,
          promo_type: data.promo_type,
          options: data.options,
          compare_type: data.compare_type,
          compare_value: data.compare_value,
          start_date: data.start_date,
          end_date: data.end_date,
          issue_limit: data.issue_limit,
          issued: data.issued,
          claim_limit: data.claim_limit,
          applied_tier: data.applied_tier,
          tier_name: data.tier_name,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        })
      }
    } else {
      //no global for membership
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target

    this.setState({
      [name]: value,
    })
  }

  promoChangeHandler = e => {
    let { name, value } = e.target

    let selected_promo = this.state.promoList.find(x => x.id == value)
    console.log(selected_promo)
    console.log(this.state.membership_tier)
    console.log(this.state.membership_promo)
    let TierOp = this.state.membership_tier.filter(x => !this.state.membership_promo.some(y => y.applied_tier === x.id && y.promo_code == selected_promo.promo_code))

    console.log(TierOp)

    this.setState({
      [name]: value,
      filter_membership_tier: TierOp,
    })
  }

  tierChangeHandler = e => {
    if (this.state.promo_id == '') {
      this.notificationSystem.addNotification({
        title: <MdClear />,
        message: 'Please select promo first',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    } else {
      let { name, value } = e.target

      this.setState({
        [name]: value,
      })
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url)
      } else {
        this.update(user, comp, url)
      }
    } else {
      //no global for membership
      this.add(user, comp, url)
    }
  }

  Promo = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/promo', data)
      .then(response => {
        const result = response.data.data
        const membership_promo = this.props.data.membership_promo

        let PromoOp = result.filter(x => !membership_promo.some(y => y.applied_tier === 0 && x.promo_code == y.promo_code))

        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            promoList: PromoOp,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: this.state.membership_id,
      tier_id: this.state.tier_id,
      promo_id: this.state.promo_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/promo/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New membership tier added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      tier_id: this.state.tier_id,
      membership_id: this.state.membership_id,
      tier_name: this.state.tier_name,
      entry_level: this.state.entry_level,
      points_type: this.state.points_type,
      max_points: this.state.max_points,
      conversion_rate: this.state.conversion_rate,
      max_claim: this.state.max_claim,
      tier_unit: this.state.tier_unit,
      expiry_duration: this.state.expiry_duration,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Membership tier updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  //   add(user, comp, url) {
  //     const data = {
  //       session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //       store_id: this.state.store_id,
  //       promo_id: this.state.promo_id,
  //       added_by: user.email,
  //     }

  //     axios
  //       .post(url + ':3001/v1/store/promo/add', data)
  //       .then(response => {
  //         const result = response.data
  //         if (result.error == true) {
  //           this.props.closeModal(<MdClear />, result.message, 'error', false)
  //           return
  //         }

  //         this.props.closeModal(<MdDone />, 'New Promo added successfully.', 'success', false)
  //       })
  //       .catch(error => {
  //         alert(error)
  //       })
  //   }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <ModalHeader toggle={this.props.onToggleModal()}>Membership Promo</ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Promo</Label>
                  <Input type="select" name="promo_id" value={this.state.promo_id} onChange={this.promoChangeHandler} required>
                    <option value=""></option>
                    {this.state.promoList.length > 0 &&
                      this.state.promoList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Tier Applied</Label>
                  <Input type="select" name="tier_id" value={this.state.tier_id} onChange={this.tierChangeHandler} required>
                    <option value=""></option>
                    <option value="0">All</option>
                    {this.state.filter_membership_tier.map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.tier_name}
                        </option>
                      )
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input type="select" name="promo_id" onChange={this.changeHandler} required>
                    <option></option>
                    {this.state.promoList &&
                      this.state.promoList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosMembershipPromoForm
